import React from 'react';
import { Box, Grid, Paper } from '@mui/material';
import ProfileForm from '../userprofile/pages/userprofilepage';
import SidebarMenu from '../userprofile/pages/SidebarMenu';

const ProfilePage = () => {
  return (
    <div>
     <div className="mylearningpaths">
    <Box
      sx={{
        py: 4,
        px: { xs: 2, sm: 4, md: 6 },
      }}
    >
      <Grid container spacing={4}>
        {/* Sidebar */}
        <Grid item xs={12} md={3}>
            <SidebarMenu />
        </Grid>

        {/* Profile Form */}
        <Grid item xs={12} md={9}>
          <Paper
            elevation={3}
            sx={{
              p: { xs: 2, sm: 3, md: 4 },
              borderRadius: 3,
              bgcolor: '#ffffff',
            }}
          >
            <ProfileForm />
          </Paper>
        </Grid>
      </Grid>
    </Box>
    </div>
    </div>
  );
};

export default ProfilePage;
